import { connect } from 'react-redux'
import { setQuery } from 'actions'

const withReduxForRouter = connect(() => {}, { setQuery })

export default withReduxForRouter
